import React from 'react';
import './styles.scss';

const Glitch = ({ text }) => (
  <div className="glitch" data-text={text}>{text}</div>
);

export default Glitch;
